import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { SecHeadAgendaService } from 'src/app/excucomm/service/sec-head-agenda.service';
import { EncrDecrService } from 'src/app/common-service/EncrDecrService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { SignupService } from 'src/app/common-service/signup.service';
import { ExcutiveService } from 'src/app/excucomm/service/excutive.service';
import { HelperService } from 'src/app/common-service/helper.service';

@Component({
  selector: 'app-create-agenda',
  templateUrl: './create-agenda.component.html',
  styleUrls: ['./create-agenda.component.css']
})
export class CreateAgendaComponent implements OnInit {
  agendaFormSubmitted = false;
  agendaForm: FormGroup;
  subscribe: Subject<any> = new Subject<any>();
  subSectionList: any = [];
  @ViewChild('openModal') openBtn: ElementRef<HTMLElement>;
  @ViewChild('agendaDismiss') agendaBtn: ElementRef<HTMLElement>;
  @ViewChild('myInput') myInputVariable: ElementRef;
  files: any = [];

  agendaItemSubject: any;
  roleName: any;
  complaintId: any;
  decryptComplaintId: any;
  registrationId: any;
  decryptRegistrationId: any;
  admissionId: any;
  decryptAdmissionId: any;
  dispatchId: any;
  decryptDispatchId: any;
  caseFileId: any;
  decryptCaseFileId: any;
  fqsrAppReqId: any;
  decryptFqsrAppId: any;
  eligibilityCertificateId: any;
  decryptEligibilityCertId: any;

  constructor(public secEcService: SecHeadAgendaService, public formBuilder: FormBuilder, public router: Router,
    private spinner: NgxSpinnerService, public toastr: ToastrService, public route: ActivatedRoute, public EncrDecr: EncrDecrService,
    public serverURL: ServerURLService, public ecservice: ExcutiveService, public signin: SignupService, public helper: HelperService) { }

  ngOnInit(): void {
    this.roleName = sessionStorage.getItem('selectedRole-usec');
    this.route.params.subscribe((params: Params) => this.decryptComplaintId = params.complaintId);
    if (this.decryptComplaintId !== null && this.decryptComplaintId !== '' && this.decryptComplaintId !== undefined) {
      this.complaintId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptComplaintId);
    }

    this.route.params.subscribe((params: Params) => this.decryptAdmissionId = params.admissionId);
    if (this.decryptAdmissionId !== null && this.decryptAdmissionId !== '' && this.decryptAdmissionId !== undefined) {
      this.admissionId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptAdmissionId);
    }

    this.route.params.subscribe((params: Params) => this.decryptDispatchId = params.dispatchId);
    if (this.decryptDispatchId !== null && this.decryptDispatchId !== '' && this.decryptDispatchId !== undefined) {
      this.dispatchId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptDispatchId);
    }

    this.route.params.subscribe((params: Params) => this.decryptCaseFileId = params.caseFileId);
    if (this.decryptCaseFileId !== null && this.decryptCaseFileId !== '' && this.decryptCaseFileId !== undefined) {
      this.caseFileId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptCaseFileId);
    }

    this.route.params.subscribe((params: Params) => this.decryptRegistrationId = params.registrationId);
    if (this.decryptRegistrationId !== null && this.decryptRegistrationId !== '' && this.decryptRegistrationId !== undefined) {
      this.registrationId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptRegistrationId);
    }

    this.route.params.subscribe((params: Params) => this.decryptFqsrAppId = params.fqsrAppReqId);
    if (this.decryptFqsrAppId !== null && this.decryptFqsrAppId !== '' && this.decryptFqsrAppId !== undefined) {
      this.fqsrAppReqId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptFqsrAppId);
    }

    this.route.params.subscribe((params: Params) => this.decryptEligibilityCertId = params.eligibilityCertificateId);
    if (this.decryptEligibilityCertId !== null && this.decryptEligibilityCertId !== '' && this.decryptEligibilityCertId !== undefined) {
      this.eligibilityCertificateId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptEligibilityCertId);
    }

    this.agendaForm = this.formBuilder.group({
      agendaItemSubj: ['', Validators.required],
      agendaMatter: ['', Validators.required],
      subSection: ['', Validators.required],
      createAgendaFile: [''],
    });

    this.agendaForm.patchValue({
      agendaItemSubj: sessionStorage.getItem('legalCaseTitile')
    });

    if (this.roleName === 'AFSecInCharge' || this.roleName === 'AdmsnIncharge' || this.roleName === 'President UG-PG'|| this.roleName === 'UGPG-DEB'|| this.roleName === 'UGPG Consultant' || this.roleName === 'AcademicIncharge'
      || this.roleName === 'LegalSecInCharge' || this.roleName === 'AEIncharge' || this.roleName === 'ISecInCharge'
      || this.roleName === 'RTISecInCharge' || this.roleName === 'ServerSecInCharge' || this.roleName === 'ARPMSecInCharge'
      || this.roleName === 'PDMSSecInCharge' || this.roleName === 'InspAsstSecty' || this.roleName === 'MSAsstSecty'
      || this.roleName === 'ARPMAsstSecty' || this.roleName === 'AcademicAsstSecty' || this.roleName === 'AdmsnAsstSecty' || this.roleName === 'PDMSAsstSecty'
      || this.roleName === 'AEAssistantSecretary' || this.roleName === 'PDMSSectionOfficer' || this.roleName === 'LegalSectionOfficer' || this.roleName === 'RTISectionOfficer'
      || this.roleName === 'AFSectionOfficer' || this.roleName === 'AESectionofficer' || this.roleName === 'AcademicSectionOfficer' || this.roleName === 'AdmsnSectionOfficer'
      || this.roleName === 'RTIAssistantSectionOfficer' || this.roleName === 'ARPMAssistantSectionOfficer' || this.roleName === 'AdmsnAssistantSectionOfficer'
      || this.roleName === 'AcademicAssistantSectionOfficer' || this.roleName === 'PDMSAssistantSectionOfficer' || this.roleName === 'AFAssistantSectionOfficer'
      || this.roleName === 'AEAssistantSectionOfficer' || this.roleName === 'LegalAssistantSectionOfficer' || this.roleName === 'LegalRetainer' || this.roleName === 'RTILegalRetainer'
      || this.roleName === 'Accountant' || this.roleName === 'DAK_Section_Executive' || this.roleName === 'Student Admission Executive' || this.roleName === 'AcademicExecutive'
      || this.roleName === 'ServerSecExecutive' || this.roleName === 'PDMSExecutive' || this.roleName === 'RTIExecutive' || this.roleName === 'AdmsnSecExecutive'
      || this.roleName === 'AFExecutive' || this.roleName === 'LegalExecutive' || this.roleName === 'AEExecutive' || this.roleName === 'ARPMSecExecutive') {
      this.getSubSectionBySectionId();
    } else {
      this.signin.deleteOauthToken().subscribe((result: any) => {
      });
    }

  }

  get f() { return this.agendaForm.controls; }


  ngAfterViewInit() {
    setTimeout(() => {
      this.openBtn.nativeElement.click();
    }, 300);
  }

   // Agenda Ceated
   agendaCreate() {
    this.agendaFormSubmitted = true;
    if (this.agendaForm.valid) {
      const obj = {
        agendaItemSubject: this.agendaForm.value.agendaItemSubj,
        // agendaItemSubject:sessionStorage.getItem('legalCaseTitile'),
        agendaItemMatter: this.agendaForm.value.agendaMatter,
        sectionId: JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId,
        roleName: sessionStorage.getItem('selectedRole-usec'),
        subSectionId: parseInt(this.agendaForm.value.subSection),
        complaintId: this.complaintId,
        admissionId: this.admissionId,
        dispatchId: this.dispatchId,
        legalcaseFileId: this.caseFileId,
        registrationId: this.registrationId,
        fqsrAppReqId: this.fqsrAppReqId,
        eligibilityCertificateId: this.eligibilityCertificateId
      };
      this.spinner.show();
      this.secEcService.createAgenda(obj).pipe(takeUntil(this.subscribe)).subscribe((agendaId: any) => {
        this.spinner.hide();
        if (agendaId != null) {
          if (this.files.length >= 1) {
            this.fileUploadECMeetingCreateAgenda(agendaId);
          } else {
            this.toastr.success('Agenda Created Successfully', 'Success', {
              timeOut: 2000
            });
            this.closeAgendaModal();
          }
        }

      }, error => {
        this.spinner.hide();
        this.toastr.error('Failed to Create Agenda', 'Error', {
          timeOut: 2000
        });
        this.closeAgendaModal();
      });
    }
  }

  getSubSectionBySectionId() {  
    this.spinner.show();    
    this.secEcService.getSubSectionBySectionId().pipe(takeUntil(this.subscribe)).subscribe((data: any) => {
      this.spinner.hide();
      this.subSectionList = data;
    }, error => {
      this.spinner.hide();
      console.log(error);
      this.helper.errorMessage(error);
    });
  }

  closeAgendaModal() {
    this.agendaForm.reset();
    this.files = [];
    sessionStorage.setItem('legalCaseTitile',"")
    if (this.router.url.includes('/main/internal/excu/sectionHead/secHeadCreateAgenda')) {
      this.router.navigate(['../main/internal/excu/sectionHead/agendaDashBoard']);
    } else if (this.router.url.includes('/main/internal/excu/sectionExcutive/secExecCreateAgenda')) {
      this.router.navigate(['../main/internal/excu/sectionExcutive/secExeAgendaDashBoard']);
    } else if (this.router.url.includes('/main/internal/grievance/section/createAgenda/')) {
      var encrypted = this.EncrDecr.set(this.serverURL.secretKey, this.complaintId);
      this.router.navigate(['../main/internal/grievance/section/compView', encrypted]);
    } else if (this.router.url.includes('/main/internal/college/admissionMonitorCellExecutive/createAgenda/')) {
      var encrypted = this.EncrDecr.set(this.serverURL.secretKey, this.admissionId);
      this.router.navigate(['../main/internal/college/admissionMonitorCellExecutive/viewStudentDetails', encrypted]);
    } else if (this.router.url.includes('/main/internal/outbound/se/createAgenda/')) {
      var encrypted = this.EncrDecr.set(this.serverURL.secretKey, this.dispatchId);
      this.router.navigate(['../main/internal/outbound/se/view', encrypted]);
    } else if (this.router.url.includes('/main/internal/outbound/secInch/createAgenda/')) {
      var encrypted = this.EncrDecr.set(this.serverURL.secretKey, this.dispatchId);
      this.router.navigate(['../main/internal/outbound/secInch/viewSheetData', encrypted]);
    } else if (this.router.url.includes('/main/internal/legal/createAgenda/')) {
      var encrypted = this.EncrDecr.set(this.serverURL.secretKey, this.caseFileId);
      this.router.navigate(['main/internal/legal/caseFileManagementView', encrypted]);
    } else if (this.router.url.includes('/main/internal/ptr/sectionExcutive/createAgenda/')) {
      var encrypted = this.EncrDecr.set(this.serverURL.secretKey, this.registrationId);
      this.router.navigate(['../main/internal/ptr/sectionExcutive/viewSecExePtrDetails', encrypted]);
    } else if (this.router.url.includes('/main/internal/fqsr/createAgenda/')) {
      var encrypted = this.EncrDecr.set(this.serverURL.secretKey, this.fqsrAppReqId);
      this.router.navigate(['/main/internal/fqsr/secViewRequest', encrypted]);
    } else if (this.router.url.includes('/main/internal/eligibility/createAgenda/')) {
      this.router.navigate(['/main/internal/eligibility/secView', this.eligibilityCertificateId]);
    } 
  }

  //For CK Editor
  config = {
    //startupFocus : true,
    versionCheck: false,
    tabSpaces: 10,
    extraPlugins: 'pastefromword,pastefromgdocs,pastefromlibreoffice,divarea,smiley,justify,indentblock,colordialog,font,exportpdf,pagebreak',
    font_names: 'कृति देवी/Kruti;Andale Mono;Arial; Arial Black; Arial Narrow; Comic Sans MS; Courier New; Georgia; Helvetica; Impact; Tahoma; Terminal; Times New Roman; Verdana;',
    removeButtons: 'Paste,PasteText,PasteFromWord',
  }

 

  // File upload
  fileUploadECMeetingCreateAgenda(agendaId) {
    this.spinner.show();
    this.ecservice.fileUploadECMeetingCreateAgenda(this.files, agendaId).pipe(takeUntil(this.subscribe)).subscribe(res => {
      this.spinner.hide();
      if (res != null) {
        this.toastr.success('Agenda Created Successfully', 'Success', {
          timeOut: 2000
        });
        this.closeAgendaModal();
      }
    }, error => {
      this.spinner.hide();
      this.toastr.error('Failed to Create Agenda', 'Error', {
        timeOut: 2000
      });
      this.closeAgendaModal();
    });
  }

  // File upload
  getFileDetails(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      let file = event.target.files[i];
      if (file.type === 'application/pdf' || file.type === 'image/png'
        || file.type === 'image/jpg' || file.type === 'image/jpeg'
        || file.type === 'text/plain' || file.type === 'application/msword'
        || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        || file.type === 'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
        || file.type === 'application/vnd.ms-excel.sheet.macroEnabled.12'
        || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
        || file.type === 'application/vnd.ms-excel' || file.type === 'text/csv') {

        this.files.push(file);
      } else {
        this.myInputVariable.nativeElement.value = "";
      }
    }
  }
  // Remove Files From List OF Files
  removed(id) {
    if (this.files[id].agendaDocumentId) {
      const obj = {
        agendaDocumentId : this.files[id].agendaDocumentId,
      };
      this.ecservice.deleteECMeetingCreateAgendaDocument(obj).subscribe((res: any) => {
        if (res!=null) {
          if(!res){
            this.toastr.error('Unable to Delete the file', 'Error', {
              timeOut: 2000
            });
          }
        } 
      }, error => {
        this.toastr.error('Unable to Delete the file', 'Error', {
          timeOut: 2000
        });
      })
    } else {
      this.files.splice(id, 1);
      if (this.files.length === 0){
        this.agendaForm.controls.createAgendaFile.setValue('', { onlySelf: true });
      }
    }

    
  }

}
